/**
 * Staff console routes (admin.quixomarketing.com) - owner: ui-agency-admin. Edit only inside this folder.
 * `/signin` and `/sign-in` are public (Entra sign-in). Everything else sits behind StaffGate.
 */
import { GrowthAuditAdminPage } from './screens/growth-audit';
import type { RouteObject } from 'react-router';
import { AdminRoot, StaffGate, StaffSignIn } from './screens/layout';
import { AdminHome } from './screens/home';
import { ApiKeysPage, AssistantPage, CrmPage, InvoicesPage, MigrationPage, PurchaseOrdersPage } from './screens/crm';
import { Customer360Page, CustomersPage, ImportPage, LeadsPage } from './screens/customers';
import { ApplicationsPage, StaffPage } from './screens/people';
import { DiagnosticsPage, ImpersonationPage, TenantDetailPage, TenantsPage } from './screens/tenants';
import { BillingPage } from './screens/billing';
import { AiControlsPage, CostsPage, FlagsPage, RescuePage } from './screens/ops';
import { SupportQueuePage } from './screens/support-queue';
import { AccessPage } from './screens/access';
import { OpportunitiesQueuePage, OpportunityAdminPage, SalesStaffPage } from './screens/opportunities';
import { CmsPageEditorPage, CmsPagesPage } from './screens/cms-pages';
import { CmsMediaPage } from './screens/cms-media';
import { CmsCollectionPage, CmsCollectionsPage } from './screens/cms-collections';
import { CmsPricesPage } from './screens/cms-prices';
import { CmsTextPage } from './screens/cms-text';
import { ContentAdminRoot, ContentAgenciesPage, ContentAgencyPage, ContentItemPage, ContentSuperAdminsPage } from './screens/content-admin';
import { auditExpertRoutes } from './audit-expert';

export const adminRoutes: RouteObject[] = [
  {
    element: <AdminRoot />,
    children: [
      { path: 'signin', element: <StaffSignIn /> },
      { path: 'sign-in', element: <StaffSignIn /> },
      {
        element: <StaffGate />,
        children: [
          { index: true, element: <AdminHome /> },
          { path: 'tenants', element: <TenantsPage /> },
          { path: 'tenants/:id', element: <TenantDetailPage /> },
          { path: 'impersonation', element: <ImpersonationPage /> },
          { path: 'diagnostics', element: <DiagnosticsPage /> },
          { path: 'customers', element: <CustomersPage /> },
          { path: 'customers/:id', element: <Customer360Page /> },
          { path: 'leads', element: <LeadsPage /> },
          { path: 'leads/import', element: <ImportPage /> },
          { path: 'crm', element: <CrmPage /> },
          { path: 'crm/invoices', element: <InvoicesPage /> },
          { path: 'crm/invoices/:id', element: <InvoicesPage /> },
          { path: 'crm/purchase-orders', element: <PurchaseOrdersPage /> },
          { path: 'crm/assistant', element: <AssistantPage /> },
          { path: 'crm/api-keys', element: <ApiKeysPage /> },
          { path: 'crm/migration', element: <MigrationPage /> },
          { path: 'partners', element: <ApplicationsPage /> },
          { path: 'partners/:id', element: <ApplicationsPage /> },
          { path: 'staff', element: <StaffPage /> },
          { path: 'billing', element: <BillingPage /> },
          { path: 'growth-audit', element: <GrowthAuditAdminPage /> },
          { path: 'rescue', element: <RescuePage /> },
          { path: 'support-queue', element: <SupportQueuePage /> },
          // Opportunities desk: quotations, negotiation, discount approvals (flag crm.opportunities; the API gates every call)
          { path: 'opportunities', element: <OpportunitiesQueuePage /> },
          { path: 'opportunities/staff', element: <SalesStaffPage /> },
          { path: 'opportunities/:id', element: <OpportunityAdminPage /> },
          { path: 'ai', element: <AiControlsPage /> },
          { path: 'flags', element: <FlagsPage /> },
          // Staff access approval: request access to a workspace / agency, my grants (flag identity.staff_access_approval)
          { path: 'access', element: <AccessPage /> },
          { path: 'costs', element: <CostsPage /> },
          // Website CMS (staff_admin + staff_content edit; ops/support/read-only view)
          { path: 'cms/pages', element: <CmsPagesPage /> },
          { path: 'cms/pages/:id', element: <CmsPageEditorPage /> },
          { path: 'cms/media', element: <CmsMediaPage /> },
          { path: 'cms/collections', element: <CmsCollectionsPage /> },
          { path: 'cms/collections/:key', element: <CmsCollectionPage /> },
          { path: 'cms/text', element: <CmsTextPage /> },
          { path: 'cms/prices', element: <CmsPricesPage /> },
          // Advanced audit expert review desk (T10): queue, review, advisor threads, bookings
          ...auditExpertRoutes,
          // Content tracker super admin console (two named super admins; the server gates every call)
          {
            path: 'content-admin',
            element: <ContentAdminRoot />,
            children: [
              { index: true, element: <ContentAgenciesPage /> },
              { path: 'items/:id', element: <ContentItemPage /> },
              { path: 'superadmins', element: <ContentSuperAdminsPage /> },
              { path: ':partnerId', element: <ContentAgencyPage /> },
            ],
          },
        ],
      },
    ],
  },
];

